import { render, staticRenderFns } from "./process-add-or-update.vue?vue&type=template&id=11c55bbb&scoped=true"
import script from "./process-add-or-update.vue?vue&type=script&lang=js"
export * from "./process-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./process-add-or-update.vue?vue&type=style&index=0&id=11c55bbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c55bbb",
  null
  
)

export default component.exports